var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapGetters } from "vuex";
import * as Screenshare from "../screenshare";
export default {
    name: "screen_menu_select",
    data: function () {
        return {
            selectedOption: undefined
        };
    },
    computed: __assign({}, mapGetters(["sharingScreenAndVideo", "supportSimultaneousScreen", "sharingScreenOnly"])),
    watch: {
        sharingScreenAndVideo: function (enabled) {
            if (enabled) {
                this.selectedOption = "screen-camera";
            }
            else {
                if (!this.sharingScreenOnly) {
                    this.selectedOption = undefined;
                }
            }
        },
        sharingScreenOnly: function (enabled) {
            if (enabled) {
                this.selectedOption = "screen-only";
            }
            else {
                if (!this.sharingScreenAndVideo) {
                    this.selectedOption = undefined;
                }
            }
        },
    },
    methods: {
        onChange: function (event) {
            var _this = this;
            this.selectedOption = undefined;
            setTimeout(function () {
                switch (event.target.value) {
                    case "screen-camera":
                        Screenshare.enableScreenAndVideo(_this.$store, _this.$socket);
                        break;
                    case "screen-only":
                        Screenshare.enableScreenOnly(_this.$store, _this.$socket);
                        break;
                    default:
                        Screenshare.stopScreen(_this.$store, _this.$socket);
                }
            }, 0);
        },
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ScreenMenuSelect.vue
// module id = 332
// module chunks = 1